<template>
  <div>
    <div id="paypal-btn" v-show="showBtn"></div>
  </div>
</template>

<script>
import { loadScript } from "@paypal/paypal-js";
export default {
  props: ["orderData"],
  data() {
    return {
      paypal: null,
      showBtn: false,
    };
  },

  methods: {
    async initPaypal() {
      try {
        let res = await this.$http.getPayConfig();
        this.paypal = await loadScript({
          clientId: res.data.clientId,
        });
        this.payOrder();
      } catch (error) {
        console.log(error, "error with paypal");
      }
    },

    async payOrder() {
      let self = this;
      if (this.paypal) {
        try {
          await this.paypal
            .Buttons({
              async onInit() {
                self.showBtn = true;
              },
              async createOrder() {
                //调起创建支付订单的接口
                if (!self.orderData) return;
                let res = await self.$http.createPayOrder(self.orderData);
                return res.data.paypalOrderId;
              },
              async onApprove(data) {
                //付款接口
                await self.$http.payCapture({
                  paypalOrderId: data.orderID,
                });
              },
              onCancel(data) {
                console.log("已取消支付");
              },
            })
            .render("#paypal-btn");
        } catch (error) {
          console.log(error, "paypal button");
        }
      }
    },
  },

  mounted() {
    this.showBtn = false;
    this.paypal = null;
    this.initPaypal();
  },
};
</script>
